<template>
  <img
    v-if="iconSrc"
    :src="iconSrc"
    :alt="ariaLabel || ''"
    :aria-hidden="ariaLabel ? undefined : 'true'"
    class="app-icon"
    :class="`icon icon-${size}`"
  />
</template>

<script setup>
/**
 * 自设计 UI 图标统一展示组件
 * 图标资源在 @/shared/assets/manifest.js 注册，禁止组件内硬编码 assets 路径
 */
import { computed } from 'vue'
import { resolveUiIcon } from '@/shared/assets/manifest'

const props = defineProps({
  /** manifest 中 UI_ICONS / UI_ICON_VARIANTS 的键名（camelCase） */
  name: {
    type: String,
    required: true,
  },
  /** 尺寸，对应 design-system .icon-xs ~ .icon-xl */
  size: {
    type: String,
    default: 'md',
    validator: (v) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(v),
  },
  /** 多状态图标：default | active */
  variant: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'active'].includes(v),
  },
  /** 无伴随可见文字时必填，供屏幕阅读器 */
  ariaLabel: {
    type: String,
    default: '',
  },
})

const iconSrc = computed(() => resolveUiIcon(props.name, props.variant))
</script>

<style scoped>
.app-icon {
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
}
</style>

<style>
/* 加载旋转：非 scoped，供业务侧 class="app-icon--spin" 使用 */
@keyframes app-icon-spin {
  to {
    transform: rotate(360deg);
  }
}
.app-icon.app-icon--spin,
.app-icon--spin {
  animation: app-icon-spin 0.85s linear infinite;
}
</style>
